import {
  SLIDE_TWO_DRAG_DROP,
  SLIDE_TWO_SET_AS_NEXT_STEP,
  SLIDE_TWO_REMOVE_STEP,
  SLIDE_TWO_APPLY_HINT,
  SLIDE_TWO_SELECT_PATH,
} from '../Redux.constants';

export const slideTwoDragDrop = (params) => ({
  type: SLIDE_TWO_DRAG_DROP,
  payload: params,
});

export const slideTwoSetAsNextStep = (params) => ({
  type: SLIDE_TWO_SET_AS_NEXT_STEP,
  payload: params,
});

export const slideTwoRemoveStep = (params) => ({
  type: SLIDE_TWO_REMOVE_STEP,
  payload: params,
});

export const slideTwoApplyHint = () => ({
  type: SLIDE_TWO_APPLY_HINT,
  payload: {},
});

export const slideTwoSelectPath = (params) => ({
  type: SLIDE_TWO_SELECT_PATH,
  payload: params,
});
